module.exports = __webpack_public_path__ + "img/ancestry-login.e9e28cbf.jpg";